import React from "react";
import { createRoot } from "react-dom/client";
import { Phase1App } from "./phase1App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Phase1App />
  </React.StrictMode>
);
